<div [ngClass]="{'open': open()}" class="sidebar is-flex is-flex-direction-column">
  <div class="wrapper-close-x">
    <div (click)="closeSidebar()" class="toggle-icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div class="wrapper-sidbar-fixed">
    <div class="brand">
      <a class="navbar-brand navbar-brand-d logo" routerLink="/home" (click)="onNavigationClick()">
        <span>Bueno</span>
      </a>
      @if (userName != '') {
      <div class="text_lg has-text-weight-bold greetings">{{ greeting|translate }}, {{ userName }}</div>
      }
    </div>
  </div>
  <app-route-search (routeSelected)="onNavigationClick()"></app-route-search>
  <div class="sidebar-container">
    <div class="inner-sidebar-container">
      <aside class="menu is-flex is-flex-direction-column is-justify-content-space-between">
        <ul class="menu-list">
          @for (item of sidebarNavigationList; track item) { @if(!((item.hideIfOnlyProperties && onlyProperties))) {
          <li>
            <a
              routerLink="{{ item.url }}"
              class="has-text-decoration-none is-flex is-align-items-center gap-3"
              [routerLinkActive]="'is-active'"
              (click)="onNavigationClick()">
              <mat-icon class="icon-sidebar" svgIcon="{{item.icon}}"></mat-icon>
              <span class="name-page">{{ item.name |translate }}</span>
            </a>
          </li>
          } }
        </ul>
        <div class="bottom_menu">
          <ul class="menu-list referral">
            <li>
              @if (showCopyConfirmation) {
              <div class="copy-confirmation">
                <mat-icon>check_circle</mat-icon>
                <span>{{ 'REFERRAL_LINK_COPIED' | translate }}</span>
              </div>
              }
              <a
                class="has-text-decoration-none is-flex is-align-items-center gap-3"
                [routerLink]="'/account/refer-a-friend'"
                (click)="onNavigationClick()">
                <mat-icon class="icon-sidebar" svgIcon="bueno-referral"></mat-icon>
                <span class="name-page">{{'SHARE_BUENO' |translate }}</span>
              </a>
            </li>
          </ul>
          <div class="row"></div>
          <ul class="menu-list">
            @for (item of bottomNavigationList; track item) {
            <li>
              @if (!item.remoteLink) {
              <a
                routerLink="{{ item.url }}"
                class="has-text-decoration-none is-flex is-align-items-center gap-3"
                [routerLinkActive]="'is-active'"
                (click)="onNavigationClick()">
                <mat-icon class="icon-sidebar" svgIcon="{{item.icon}}"></mat-icon>
                <span class="name-page">{{ item.name |translate }}</span>
              </a>
              } @else {
              <a
                href="{{ item.url }}"
                target="_blank"
                class="has-text-decoration-none is-flex is-align-items-center gap-3"
                [routerLinkActive]="'is-active'"
                (click)="onNavigationClick()">
                <mat-icon class="icon-sidebar" svgIcon="{{item.icon}}"></mat-icon>

                <span class="name-page">{{ item.name |translate }}</span>
              </a>
              }
            </li>
            }
          </ul>
        </div>
      </aside>
    </div>
  </div>
</div>
